__turbopack_export_value__({
  "action": "accommodations-module__8p3N-W__action",
  "actionRow": "accommodations-module__8p3N-W__actionRow",
  "actionSecondary": "accommodations-module__8p3N-W__actionSecondary",
  "body": "accommodations-module__8p3N-W__body",
  "card": "accommodations-module__8p3N-W__card",
  "card-enter": "accommodations-module__8p3N-W__card-enter",
  "cardTitle": "accommodations-module__8p3N-W__cardTitle",
  "description": "accommodations-module__8p3N-W__description",
  "distance": "accommodations-module__8p3N-W__distance",
  "distanceIcon": "accommodations-module__8p3N-W__distanceIcon",
  "eyebrow": "accommodations-module__8p3N-W__eyebrow",
  "feature": "accommodations-module__8p3N-W__feature",
  "featureList": "accommodations-module__8p3N-W__featureList",
  "grid": "accommodations-module__8p3N-W__grid",
  "header": "accommodations-module__8p3N-W__header",
  "image": "accommodations-module__8p3N-W__image",
  "inner": "accommodations-module__8p3N-W__inner",
  "media": "accommodations-module__8p3N-W__media",
  "metaRow": "accommodations-module__8p3N-W__metaRow",
  "note": "accommodations-module__8p3N-W__note",
  "notes": "accommodations-module__8p3N-W__notes",
  "notesHeading": "accommodations-module__8p3N-W__notesHeading",
  "notesList": "accommodations-module__8p3N-W__notesList",
  "placeholderEyebrow": "accommodations-module__8p3N-W__placeholderEyebrow",
  "placeholderVisual": "accommodations-module__8p3N-W__placeholderVisual",
  "price": "accommodations-module__8p3N-W__price",
  "recommendedBadge": "accommodations-module__8p3N-W__recommendedBadge",
  "section": "accommodations-module__8p3N-W__section",
  "subtitle": "accommodations-module__8p3N-W__subtitle",
  "tag": "accommodations-module__8p3N-W__tag",
  "tags": "accommodations-module__8p3N-W__tags",
  "title": "accommodations-module__8p3N-W__title",
  "titleGroup": "accommodations-module__8p3N-W__titleGroup",
});
